import { type InsuranceCorporateIdentity } from "../types";

export function BkkDurkoppAdlerLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.4 258.6C159.4 275.2 158.7 278.8 153.2 278.8H148.8V236.9H152.8C159.1 236.9 159.4 242.8 159.4 256.2V258.6ZM165.2 258.6V256.2C165.2 240.7 164.7 232.2 152.8 232.2H143.3V283.4H153.4C164.9 283.4 165.2 274.5 165.2 258.6Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.4 229.8H181.6V224H177.4V229.8ZM186.6 229.8H190.7V224H186.6V229.8ZM194 272.6V235.1H188.8V272.5C188.8 276.8 188.2 280.1 184.1 280.1C180 280.1 179.4 276.8 179.4 272.5V235.1H174.2V272.5C174.2 279.4 176.4 284.1 184.2 284.1C191.8 284.2 194 279.2 194 272.6Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.4 247.5C218.4 253.6 217.2 256.9 212.8 256.9H208.7V239.3H212.9C217.3 239.3 218.4 241.9 218.4 247.5ZM224.1 283.4C223.5 281.1 223.3 277.6 223.3 275.7C223.3 275.7 223.2 268.9 223.2 267.2C223.2 260.9 220.7 259.7 217 259C221.3 257.9 223.7 255.6 223.7 247.6C223.7 239 221 235.2 213.8 235.2H203.6V283.5H208.8V261.1H212.7C216.5 261.1 218 262.6 218.1 267.7L218.2 276.1C218.2 278.3 218.3 281.6 219 283.3H224.1V283.4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M233.3 283.4H238.5V235.1H233.3V283.4ZM255.7 283.4L243.9 257.6L254.5 235.1H248.9L238.7 257.6L249.8 283.4H255.7Z"
        fill="white"
      />
    </svg>
  );
}

export const BKKDurkoppAdler: InsuranceCorporateIdentity = {
  id: "bkk-durkopp-adler",
  name: "BKK Dürkopp Adler",
  logo: BkkDurkoppAdlerLogo,
  backgroundColor: "#93C01F",
  textColor: "#FFFFFF",
  wildcard: "dürkopp adler",
  type: "statutory",
};
